import { Component, OnInit } from '@angular/core';
import { ShapeComponent } from '../../components/shape/shape.component';
import { MousePosition, IMSI } from '../../model/shape';
import { ShapeType } from '../../model/shape-types';

@Component({
  selector: 'app-imsi',
  templateUrl: './imsi.component.html',
  styleUrls: ['./imsi.component.scss']
})
export class ImsiComponent extends ShapeComponent implements OnInit {

  constructor() {
    super();
    //   console.log('TextComponent constructor');
    this.shape = new IMSI();
    this.shapeType = ShapeType.IMSI;
  }

  ngOnInit() {
    //   console.log('TextComponent ngOnInit');
  }

  updateShapeProperties(value: any) {
    if (this.shape instanceof IMSI) {
      this.shape.shapeProperties.name = value.name;
      this.shape.value = value.value;
      this.shape.originX = value.x;
      this.shape.originY = value.y;
    }
  }

  setStyles() {
    const styles = {
      fill: this.shape.shapeProperties.strokeColor
    };
    return styles;
  }

  startDrawing(beginPosition: MousePosition): void {
    if (this.shape instanceof IMSI) {
      this.shape.originX = beginPosition.x;
      this.shape.originY = beginPosition.y;
      this.shape['font-family'] = 'Arial';
      this.shape['font-size'] = 16;
    }
    //   console.log('MCC startDrawing at ', beginPosition, ', ', this.shape);
  }
}

